import MatchRequestBox from "@/components/Match/MatchRequestBox";
import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import { colors, VStack } from "goi_common";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import SeaBurialList from "./SeaBurialList";

const TAB_NAME = ["request", "list"];

export default function SeaBurialTabSection({
  district,
  regionSeaBurial,
  eventPath,
}: {
  district?: string;
  regionSeaBurial: Array<any>;
  eventPath: "sea_burial" | "sea_burial_region";
}) {
  const [tabIndex, setTabIndex] = useState(0);

  const router = useRouter();

  useEffect(() => {
    const index = TAB_NAME.findIndex((name) => name === location.hash.slice(1));

    if (index >= 0) {
      setTabIndex(index);
    } else {
      setTabIndex(0);
    }
  }, []);
  return (
    <VStack>
      <Tabs
        isFitted
        index={tabIndex}
        onChange={(index) => setTabIndex(index)}
        style={{ color: `${colors.gray500}`, borderColor: `${colors.gray300}` }}
      >
        <TabList>
          <Tab
            style={{
              fontSize: "14px",
            }}
            onClick={() => {
              router.replace("#request");
            }}
            _selected={{
              color: `${colors.black}`,
              borderColor: `${colors.black}`,
              fontWeight: 700,
            }}
          >
            장례 전체 비용 알아보기
          </Tab>
          <Tab
            style={{
              fontSize: "14px",
            }}
            onClick={() => {
              router.replace("#list");
            }}
            _selected={{
              color: `${colors.black}`,
              borderColor: `${colors.black}`,
              fontWeight: 700,
            }}
          >
            {district ? `${district} ` : ""}바다장 전체 목록
          </Tab>
        </TabList>
        <div style={{ marginTop: "16px" }} />
        <TabPanels>
          <TabPanel padding="12px 0px">
            {tabIndex === 0 && (
              <MatchRequestBox path={eventPath} position="bt" isResponsive={false} />
            )}
          </TabPanel>
          <TabPanel padding="0">
            {tabIndex === 1 && (
              <SeaBurialList regionSeaBurial={regionSeaBurial} eventPath={eventPath} />
            )}
          </TabPanel>
        </TabPanels>
      </Tabs>
    </VStack>
  );
}
